// Duplicated from @shopee/authentication-redirect

export enum RedirectType {
  External = '1',
  Internal = '2',
}

export enum UrlMatchType {
  ExactMatch = '1',
  HostnameRegex = '2',
  HostnameAndPathnameRegex = '3',
}
